<div class="p-l-5 p-r-5 pos-relative"
     [ngClass]="whiteMode ? 'b-col-w' : 'b-col-4'"
     [class.b-b]="expandableLayout !== 'filled'"
     [ngSwitch]="!!expandableTitle"
     (offClick)="toggle(false)"
     [offClickOff]="offClickClose && !openState.value">
    <div class="flex flex-justify-between cursor-pointer col-1"
         [ngClass]="expandableLayout ==='filled' ? 'p-t-3 p-b-3' : 'p-t-5 p-b-5'"
         (click)="toggle()">

        <!-- title -->
        <div class="flex-grow w-12 _title">
            <label [ngClass]="expandableLayout ==='filled' ? 'p2' : 's1'"
                   class="cursor-pointer"
                   [class.col-w]="whiteMode"
                   *ngSwitchCase="true">
                {{expandableTitle}}
            </label>
            <ng-container *ngSwitchCase="false">
                <ng-container *ngTemplateOutlet="expandableTitleTpl"></ng-container>
            </ng-container>
        </div>
        <!-- icon -->
        <div class="col-6"
             [lineHeightBy]="expandableLayout ==='filled' ? 'p2' : 's1'">
            <i [toggleClassBy]="openState"
               [toggleClass]="'!icon-plus icon-minus'"
               [class.col-w]="whiteMode"></i>
        </div>
    </div>

    <!-- body -->
    <div [hideUp]="openState">
        <div [ngClass]="expandableLayout ==='filled' ? 'p-b-3' : 'p-b-5'">
            <ng-container *ngSwitchCase="true">
                <ng-container *ngTemplateOutlet="expandableContentTpl"></ng-container>
            </ng-container>
            <ng-container *ngSwitchCase="false">
                <ng-container *ngTemplateOutlet="expandableBodyTpl"></ng-container>
            </ng-container>
        </div>
    </div>
</div>

<ng-template #expandableTitleTpl>
    <ng-content select="[expandableTitle]"></ng-content>
</ng-template>
<ng-template #expandableBodyTpl>
    <ng-content select="[expandableBody]"></ng-content>
</ng-template>
<ng-template #expandableContentTpl>
    <ng-content></ng-content>
</ng-template>